var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.882 3a2.48 2.48 0 0 1 2.481 2.482v1.283h3.166a2.48 2.48 0 0 1 2.482 2.482v9.411c0 1.37-1.111 2.482-2.482 2.483H4.471a2.483 2.483 0 0 1-2.483-2.483v-9.41a2.48 2.48 0 0 1 2.483-2.483h3.164V5.482A2.484 2.484 0 0 1 10.117 3zm2.481 16.94h3.166c.708 0 1.282-.574 1.282-1.282v-9.41c0-.709-.574-1.284-1.282-1.284h-3.166zm-7.529 0h6.33V7.964h-6.33zM4.471 7.964c-.709 0-1.283.575-1.283 1.283v9.411c0 .708.575 1.282 1.283 1.282h3.164V7.964zm5.646-3.765a1.285 1.285 0 0 0-1.283 1.283v1.283h6.33V5.482A1.284 1.284 0 0 0 13.882 4.2z"
  })));
};
export default SvgBriefcase;